/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cat_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cat_medium_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M3.511 16.022a6.966 6.966 0 0 1-.477-2.56m13.466 7.63a7.892 7.892 0 0 1-9 0m12.989-5.07a6.976 6.976 0 0 0 .477-2.56M9.75 19.509a2.76 2.76 0 0 0 1.32-.46 2.79 2.79 0 0 0 .93-1.052m0 0c.216.425.536.787.93 1.051a2.76 2.76 0 0 0 1.32.461M12 17.997v-.085m6.75-2.182 4.5.755M18 17.997l3.75 2.268m-16.5-4.536-4.5.756M6 17.997l-3.75 2.268m.784-6.803L3 3.002c0-1.212 1.471-1.96 2.437-1.18L10.639 6m-7.605 7.46C3.073 9.576 6.654 6.57 10.64 6m10.326 7.46L21 3.002c0-1.239-1.477-1.954-2.437-1.18l-5.267 4.18m7.67 7.46c-.039-3.884-3.674-6.89-7.67-7.46M10.64 6a9.113 9.113 0 0 1 2.656 0M12 17.912c.982 0 1.964-.601 2.25-1.804 0-.63-1.007-1.134-2.25-1.134s-2.25.504-2.25 1.134c.286 1.203 1.268 1.804 2.25 1.804ZM8.823 12.01h.346m5.652 0h.346m-5.919 0c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm5.998 0c0 .183-.16.243-.248.243-.091 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Z"
      />
    </g>
    <defs>
      <clipPath id="cat_medium_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cat_medium
